import axios from "axios";


const clienteAxios = axios.create({
  baseURL: process.env.VUE_APP_RUTA_API,
  
})

export default clienteAxios;